import {FolderType} from "@/ts/enums/FolderType";
import Folder from "@/ts/interfaces/Folder";

export default {
    state: {
        dialogVisible: false,
        isEdit: false,
        folder: {},
        name: "",
        order_index: 0,
        files: [],
        demoVideoUrl: "",
        demoFile: {},
        items: [FolderType.PARENT, FolderType.FORMULAR, FolderType.IMAGE, FolderType.FREE, FolderType.DOCUMENTATION],
        select: FolderType.PARENT
    },
    show(isProjectSection: boolean) {
        if (isProjectSection) {
            this.state.items = [FolderType.PARENT, FolderType.FORMULAR, FolderType.LEISTUNG, FolderType.LEISTUNG_OHNE_PREISE, FolderType.IMAGE, FolderType.FREE, FolderType.DOCUMENTATION]
        }
        this.state.dialogVisible = true;
    },
    showEdit(folder: Folder, isProjectSection: boolean) {
        if (isProjectSection) {
            this.state.items = [FolderType.PARENT, FolderType.FORMULAR, FolderType.LEISTUNG, FolderType.LEISTUNG_OHNE_PREISE, FolderType.IMAGE, FolderType.FREE, FolderType.DOCUMENTATION]
        }
        this.state.dialogVisible = true;
        this.state.isEdit = true;
        this.state.folder = folder;
        this.state.name = folder.name;
        this.state.order_index = folder.order_index;
        this.state.demoVideoUrl = folder.demo_video_url;
    },
    dismiss() {
        this.state.items = [FolderType.PARENT, FolderType.FORMULAR, FolderType.IMAGE, FolderType.FREE, FolderType.DOCUMENTATION]
        this.state.dialogVisible = false;
        this.state.isEdit = false;
        this.state.folder = {};
        this.state.name = "";
        this.state.order_index = 0;
        this.state.files = [];
        this.state.demoVideoUrl = "";
        this.state.demoFile = {};
        this.state.select = FolderType.PARENT
    }
}
